import { render, staticRenderFns } from "./ProductClassCardPricing.vue?vue&type=template&id=fdad9f22&scoped=true&"
import script from "./ProductClassCardPricing.vue?vue&type=script&lang=js&"
export * from "./ProductClassCardPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdad9f22",
  null
  
)

export default component.exports